export const paragraphColor = (isPublished: boolean) =>
  isPublished ? 'neutral' : 'neutral-4'
